(function () {
  function initTierBar() {
    var bars = document.querySelectorAll('[data-hf-tier-bar]:not([data-hf-tier-init])');
    bars.forEach(function (bar) {
      bar.setAttribute('data-hf-tier-init', 'true');

      var raw = bar.getAttribute('data-tiers') || '';
      var tiers = raw.split(',').map(function (part) {
        var pieces = part.split(':');
        return { qty: parseInt(pieces[0], 10), label: pieces[1] || '' };
      }).filter(function (t) { return !isNaN(t.qty) && t.qty > 0; });

      if (tiers.length === 0) return;

      // Optional: restrict live cart counting to items of a given product_type
      // (case-insensitive substring match). Used to count "t-shirt" items only,
      // so a hoodie or mug in the basket doesn't inflate progress toward a
      // shirts-only discount ladder. When absent, every cart item counts.
      var itemTypeFilter = (bar.getAttribute('data-item-type-filter') || '').trim().toLowerCase();

      var track = bar.querySelector('[data-hf-tier-fill]');
      var message = bar.querySelector('[data-hf-tier-message]');
      var markerEls = bar.querySelectorAll('.hf-tier-bar__marker');
      var n = tiers.length;

      // The markup is server-rendered by Liquid with the correct fill width,
      // marker states (is-complete / is-current / is-upcoming) and message
      // already in place for the page's initial cart state -- this script
      // only has to keep that in sync as the cart changes via AJAX, so a
      // failure here never leaves the widget looking broken or blank.

      function dotPosition(index) {
        return n > 1 ? (index / (n - 1)) * 100 : 100;
      }

      function render(qty) {
        var fillPct;

        if (qty <= 0) {
          fillPct = 0;
        } else if (qty >= tiers[n - 1].qty) {
          fillPct = 100;
        } else {
          var segStartQty = 0;
          var segStartPos = 0;
          var segEndQty = tiers[0].qty;
          var segEndPos = dotPosition(0);

          for (var i = 0; i < n; i++) {
            if (qty < tiers[i].qty) {
              segEndQty = tiers[i].qty;
              segEndPos = dotPosition(i);
              segStartQty = i > 0 ? tiers[i - 1].qty : 0;
              segStartPos = i > 0 ? dotPosition(i - 1) : 0;
              break;
            }
          }

          var segRange = segEndQty - segStartQty;
          var fraction = segRange > 0 ? (qty - segStartQty) / segRange : 1;
          fillPct = segStartPos + fraction * (segEndPos - segStartPos);
        }

        if (track) track.style.width = fillPct + '%';

        markerEls.forEach(function (marker, index) {
          var dotQty = parseInt(marker.getAttribute('data-qty'), 10);
          var prevQty = index > 0 ? tiers[index - 1].qty : 0;
          var wasComplete = marker.classList.contains('is-complete');
          marker.classList.remove('is-complete', 'is-current', 'is-upcoming');
          if (qty >= dotQty) {
            marker.classList.add('is-complete');
            // Only ever fires from a real live cart change (this function
            // never runs on initial page load), so this is always a genuine
            // "just crossed this threshold" moment worth a little flash.
            if (!wasComplete) {
              marker.classList.add('is-just-unlocked');
              setTimeout(function () {
                marker.classList.remove('is-just-unlocked');
              }, 700);
            }
          } else if (qty >= prevQty) {
            marker.classList.add('is-current');
          } else {
            marker.classList.add('is-upcoming');
          }
        });

        var nextTier = null;
        for (var j = 0; j < tiers.length; j++) {
          if (qty < tiers[j].qty) { nextTier = tiers[j]; break; }
        }

        if (message) {
          if (nextTier) {
            var remaining = nextTier.qty - qty;
            var itemWord = remaining === 1 ? 'item' : 'items';
            message.textContent = 'Add ' + remaining + ' more ' + itemWord + ' to unlock ' + nextTier.label;
          } else {
            message.textContent = 'All tiers unlocked — ' + tiers[tiers.length - 1].label + ' applied!';
          }
        }
      }

      function countCartQty(cart) {
        if (!itemTypeFilter) {
          return cart.item_count || 0;
        }
        var items = cart.items || [];
        var total = 0;
        for (var i = 0; i < items.length; i++) {
          var type = (items[i].product_type || '').trim().toLowerCase();
          if (type.indexOf(itemTypeFilter) !== -1) {
            total += items[i].quantity || 0;
          }
        }
        return total;
      }

      function refreshFromCart() {
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) { render(countCartQty(cart)); })
          .catch(function () { /* leave last known (server-rendered) state */ });
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshFromCart);
      }

      setInterval(refreshFromCart, 4000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTierBar);
  } else {
    initTierBar();
  }
  window.addEventListener('load', initTierBar);
})();
